<template>
	<div class="empty">
		<img src="@/assets/empty_icon.png" />
		<span>{{content}}</span>
		<!-- <a class="public-btn" href="javascript:;">立即发表</a> -->
	</div>
</template>

<script>
	export default {
		props: {
			content: {
				type: String,
				value: ''
			}
		}
	}
</script>

<style lang="less" scoped>
	.empty{
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		width: 260px;
		margin: 60px auto;
		img{
			width: 260px;
			height: 230px;
		}
		span{
			padding: 20px 0 30px;
			color: var(--color-text-opacity);
		}
		.public-btn{
			display: block;
			width: 88px;
			height: 34px;
			background: #CF171D;
			border-radius: 16px;
			line-height: 34px;
			text-align: center;
			color: #fff;
		}
	}
</style>
